const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Product quantity limits — no limits enforced; customers can order as many samples as they want.
function getProductQuantityLimits() {
  return {};
}

const PRODUCT_QUANTITY_LIMITS = getProductQuantityLimits();

/**
 * Get total quantity for a product ID in the cart
 * @param {number} productId - Product ID to check
 * @returns {Promise<number>} Total quantity of the product in cart
 */
async function getProductQuantityInCart(productId) {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) return 0;
    
    const cart = await response.json();
    if (!cart.items || !Array.isArray(cart.items)) return 0;
    
    // Convert productId to number for comparison (cart.js returns numbers)
    const productIdNum = typeof productId === 'string' ? parseInt(productId, 10) : productId;
    
    return cart.items
      .filter(item => item.product_id === productIdNum)
      .reduce((total, item) => total + item.quantity, 0);
  } catch (error) {
    console.error('Error fetching cart:', error);
    return 0;
  }
}

/**
 * Check if adding quantity would exceed the limit for a product
 * @param {number} productId - Product ID to check
 * @param {number} quantityToAdd - Quantity being added
 * @returns {Promise<{allowed: boolean, currentQuantity: number, maxQuantity: number, message: string}>}
 */
async function checkProductQuantityLimit(productId, quantityToAdd) {
  // Convert productId to string for lookup (PRODUCT_QUANTITY_LIMITS uses string keys)
  const productIdStr = String(productId);
  const maxQuantity = PRODUCT_QUANTITY_LIMITS[productIdStr];
  
  if (!maxQuantity) {
    // No limit configured for this product, allow it
    return { allowed: true, currentQuantity: 0, maxQuantity: null, message: '' };
  }
  
  const currentQuantity = await getProductQuantityInCart(productId);
  const newTotal = currentQuantity + quantityToAdd;
  
  if (newTotal > maxQuantity) {
    return {
      allowed: false,
      currentQuantity,
      maxQuantity,
      message: `Maximum ${maxQuantity} samples allowed per customer. You already have ${currentQuantity} in your cart.`
    };
  }
  
  return {
    allowed: true,
    currentQuantity,
    maxQuantity,
    message: ''
  };
}
